import React, { useMemo, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTable, usePagination, useSortBy, useExpanded, useResizeColumns, useFlexLayout } from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
import FolderMoveOutlineIcon from 'mdi-react/FolderMoveOutlineIcon';
import VectorPolylineRemoveIcon from 'mdi-react/VectorPolylineRemoveIcon';
import LinkVariantRemoveIcon from 'mdi-react/LinkVariantRemoveIcon';
import InfoOutlineIcon from 'mdi-react/InfoOutlineIcon';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import { reducer, useEffectToDispatch, fetchApiData, initialState, TableFilter, Sorting } from "@/shared/apiTableHelper"
import { getProgramById } from "@/shared/apiHelper"
import axios from "axios";
import ChangeStatusModal from "@/containers/Program/components/ChangeStatusModal"
import ProgramBreadcrumb from '@/shared/components/ProgramBreadcrumb'
import { CSVLink } from "react-csv";

import {
  Button,
  Container,
  Card,
  CardBody,
  ButtonToolbar,
  Row,
  Col,
} from "reactstrap";
import ProgramFilter from "../../components/ProgramsFilter";

// import AddSubProgramForm from './AddSubProgramModal';
import { PROGRAM_COLUMNS } from "./columns";

import { renameChildrenToSubrows } from '@/shared/helpers'
import AddSubProgramModal from './AddSubProgramModal'
import MoveSubProgramModal from "./MoveSubProgramModal"
import { useDispatch, sendFlashMessage } from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fetchApiDataExport } from "@/shared/apiTableHelper";

const queryClient = new QueryClient()

const DataTable = ({ organization, program }) => {
  // console.log(program)
  const flashDispatch = useDispatch()

  const [filter, setFilter] = useState({ status: '', keyword: '' });
  const [useFilter, setUseFilter] = useState(false);
  const [movingSubProgram, setMovingSubProgram] = useState(null)
  const [isMoveOpen, setMoveOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [trigger, setTrigger] = useState(0);

  const [isChangeStatusOpen, setChangeStatusOpen] = useState(false)
  const [subprogram, setSubprogram] = useState(null) //used in change status modal
  const [exportData, setExportData] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [exportToCsv, setExportToCsv] = useState(false);
  const exportLink = React.createRef();

  const history = useHistory();
  const onClickStartMoveSubProgram = (program) => {
    setMovingSubProgram(program)
    setMoveOpen(true)
  }

  const onClickUnlink = (program, removeTree = false) => {
    if (!window.confirm(`Are you sure to remove sub program${removeTree ? ' and sub tree' : ''}?`)) {
      return;
    }
    setLoading(true)
    let url = `/organization/${program.organization_id}/subprogram/${program.id}/unlink`;
    if (removeTree) {
      url += '?subtree=1'
    }
    axios.patch(url)
      .then((res) => {
        // console.log(res)
        // console.log(res.status == 200)
        if (res.status == 200) {
          // var t = setTimeout(window.location = '/', 500)
          // window.location = '/program?message=Sub program removed successfully!'
          flashDispatch(sendFlashMessage('Program has been deleted', 'alert-success', 'top'))
          setTrigger(Math.floor(Date.now() / 1000))
        }
      })
      .catch(error => {
        console.log(error.response.data);
        setLoading(false)
      })
  }
  const onClickArchive = (program) => {
    if (!window.confirm(`Are you sure to archived sub program ?`)) {
      return;
    }
    setLoading(true)
    let url = `/organization/${program.organization_id}/program/${program.id}/archived`;
    axios.put(url)
      .then((res) => {
        if (res.status === 200) {
          flashDispatch(sendFlashMessage('Program has been archived', 'alert-success', 'top'))
          setTrigger(Math.floor(Date.now() / 1000))
        }
      })
      .catch(error => {
        console.log(error.response.data);
        flashDispatch(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger', 'top'))
      })
      .finally(()=>setLoading(false));
  }

  useEffect(() => {
    if (exportToCsv && exportLink.current) {
      exportLink.current.link.click();
      setExportToCsv(false);
    }
  }, [exportToCsv]);

  const onExportHierarchy = async () => {
    setLoading(true);
    const exportUrl = `/organization/${program.organization_id}/program/${program.id}/export-hierarchy`;

    try {
      const response = await fetchApiDataExport({
        url: exportUrl,
        sortby: queryPageSortBy,
      });

      // Store the export data
      setExportData(response.results.data);
      setExportHeaders(response.headers);
      setExportToCsv(true);
    } catch (error) {
      console.error('Error exporting data:', error);
      flashDispatch(sendFlashMessage('Failed to export data', 'alert-danger', 'top'));
    } finally {
      setLoading(false);
    }
  };

  // var [data, setData] = useState([]);
  const [isOpen, setOpen] = useState(false)

  const toggle = () => {
    setOpen(prevState => !prevState)
  }
  const moveToggle = () => {
    setMoveOpen(prevState => !prevState);
  };
  const onClickFilterCallback = (status, keyword) => {
    // alert(JSON.stringify({status, keyword}))
    // alert(JSON.stringify(filter))
    if (filter.status === status && filter.keyword === keyword) {
      alert('No change in filters')
      setUseFilter(false);
      return
    }
    setUseFilter(true);
    setFilter({ status, keyword })
    // alert(status, keyword)
  }

  const RenderActions = ({ row }) => {
    return (
      <>
        <span title="View"><InfoOutlineIcon style={{ cursor: 'pointer' }} onClick={() => { window.location.href = `/program/view/${row.original.id}` }} disabled={loading} /></span>
        <span style={{ width: '15px', display: 'inline-block' }}></span>
        <span title="Move node"><FolderMoveOutlineIcon onClick={() => onClickStartMoveSubProgram(row.original)} style={{ cursor: 'pointer' }} disabled={loading} /></span>
        <span style={{ width: '15px', display: 'inline-block' }}></span>
        <span title="Delete with subtree"><VectorPolylineRemoveIcon disabled={loading} style={{ cursor: 'pointer' }} onClick={() => onClickUnlink(row.original, true)} title="Delete sub program and sub tree" /></span>
        <span style={{ width: '15px', display: 'inline-block' }}></span>
        <span title="Delete only this node"><LinkVariantRemoveIcon disabled={loading} style={{ cursor: 'pointer' }} onClick={() => onClickUnlink(row.original)} /></span>
        <span style={{ width: '15px', display: 'inline-block' }}></span>
        <span title="Archive"><ArchiveOutlinedIcon disabled={loading} style={{ cursor: 'pointer' }} onClick={() => onClickArchive(row.original)} /></span>
      </>
    )
  }
  const toggleChangeStatus = () => {
    setChangeStatusOpen(prevState => !prevState)
  }
  const onClickStatus = p => {
    setSubprogram(p);
    toggleChangeStatus()
  }

  const strShowUserStatus = p => {
    return p?.status?.status ? <span onClick={() => onClickStatus(p)} className={'link'}>{p.status.status}</span> : (p?.status_id ? p.status_id : 'unknown')
  }

  let columnns = [
    ...PROGRAM_COLUMNS,
    ...[{
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => <RenderActions row={row} />,
    }]
  ]

  columnns.forEach( (column, i) => {
    if( column.Header === 'Status')
    {
      columnns[i].Cell =  ({ row, value }) => { return strShowUserStatus(row.original)}
    }
})

  let columns = useMemo(() => columnns, [])


  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 30,
      width: 150,
      maxWidth: 400,
    }),
    []
  )

  const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryTrigger }, dispatch] =
    React.useReducer(reducer, initialState);

  const apiUrl = `/organization/${program.organization_id}/program/${program.id}/subprogram`

  const { isLoading, error, data, isSuccess } = useQuery(
    ['roles', apiUrl, queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryTrigger],
    () => fetchApiData(
      {
        url: apiUrl,
        page: queryPageIndex,
        size: queryPageSize,
        filter: queryPageFilter,
        sortby: queryPageSortBy,
        trigger: queryTrigger
      }),
    {
      keepPreviousData: true,
      staleTime: Infinity,
    }
  );

  const totalPageCount = Math.ceil(totalCount / queryPageSize)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    pageCount,
    pageOptions,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy }
  } = useTable({
    columns,
    data: data ? data.results : [],
    initialState: {
      pageIndex: queryPageIndex,
      pageSize: queryPageSize,
      sortBy: queryPageSortBy,
    },
    manualPagination: true, // Tell the usePagination
    pageCount: data ? totalPageCount : null,
    autoResetSortBy: false,
    autoResetExpanded: false,
    autoResetPage: false,
    defaultColumn,

  },
    useSortBy,
    useExpanded,
    usePagination,
    useResizeColumns,
    useFlexLayout,
  );
  // const [statusFilterValue, setStatusFilterValue] = useState("");
  const manualPageSize = []

  //   console.log(data)

  if (data?.results?.length > 0) {
    data.results = renameChildrenToSubrows(data.results);
  }

  useEffectToDispatch(dispatch, { pageIndex, pageSize, gotoPage, sortBy, filter, data, useFilter, trigger });

  if (error) {
    return <p>Error: {JSON.stringify(error)}</p>;
  }

  if (isLoading) {
    return <p>Loading...</p>;
  }
  if (isSuccess)
    return (
      <>
        <div className='table react-table'>
          <div className="form form--horizontal">
            <div className="form__form-group">
              <div className="col-md-9 col-lg-9">
                <ProgramFilter onClickFilterCallback={onClickFilterCallback} organization={organization} />
                {/* <TableFilter filter={filter} setFilter={setFilter} setUseFilter={setUseFilter} label={'programs'} /> */}
              </div>
              <div className="col-md-3 col-lg-3 text-right pr-0 flex">
                <Link style={{ maxWidth: '200px' }}
                  className="btn btn-primary account__btn account__btn--small mr-3"
                  onClick={() => toggle()} to="#"
                >Add Sub program
                </Link>
                <Link
                  className="btn btn-primary account__btn account__btn--small"
                  onClick={() => onExportHierarchy()} to="#"
                >Export hierarchy
                </Link>
                <CSVLink
                  data={exportData}
                  headers={exportHeaders}
                  filename="subprogram_hierarchy.csv"
                  className="hidden"
                  ref={exportLink}
                  target="_blank"
                />
              </div>
            </div>
          </div>
          <Link className="mt-n4 mb-4 mr-4 float-right" onClick={() => history.push(`/program/${program.id}/subprograms/archive`)}>Archived Sub Programs</Link>
          <AddSubProgramModal program={program} organization={organization} isOpen={isOpen} setOpen={setOpen} toggle={toggle} setTrigger={setTrigger} />
          <table {...getTableProps()} className="table">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render('Header')}
                      {column.isSorted ? <Sorting column={column} /> : ''}
                      <div
                        {...column.getResizerProps()}
                        className={`resizer ${column.isResizing ? 'isResizing' : ''
                          }`}
                      />
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="table table--bordered" {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row);
                // console.log(row)
                const subCount = (row.id.match(/\./g) || []).length
                // const paddingCount = subCount > 0 ? Number(subCount) + 3 : 0;
                // console.log(subCount)
                return (
                  <tr {...row.getRowProps()}>
                    {
                      row.cells.map(cell => {
                        // console.log(cell)
                        const paddingLeft = subCount * 20
                        return <td {...cell.getCellProps()}><span style={cell.column.Header === '#' ? { paddingLeft: `${paddingLeft}px` } : null}>{cell.render('Cell')}</span></td>
                      })
                    }
                  </tr>
                )
              })}
            </tbody>
          </table>
          {movingSubProgram && <MoveSubProgramModal organization={organization} isOpen={isMoveOpen} setOpen={setMoveOpen} toggle={moveToggle} subprogram={movingSubProgram} setTrigger={setTrigger} />}
          {subprogram && <ChangeStatusModal isOpen={isChangeStatusOpen} setOpen={setChangeStatusOpen} toggle={toggleChangeStatus} setTrigger={setTrigger} program={subprogram} />}
        </div>
        {(rows.length > 0) && (
          <>
            <ReactTablePagination
              page={page}
              gotoPage={gotoPage}
              previousPage={previousPage}
              nextPage={nextPage}
              canPreviousPage={canPreviousPage}
              canNextPage={canNextPage}
              pageOptions={pageOptions}
              pageSize={pageSize}
              pageIndex={pageIndex}
              pageCount={pageCount}
              setPageSize={setPageSize}
              manualPageSize={manualPageSize}
              dataLength={totalCount}
            />
            <div className="pagination justify-content-end mt-2">
              <span>
                Go to page:{' '}
                <input
                  type="number"
                  value={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                  }}
                  style={{ width: '100px' }}
                />
              </span>{' '}
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
              >
                {[10, 20, 30, 40, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
      </>
    )
}

const SubProgram = ({ organization, program }) => {

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Sub Programs</h3>
          <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / <Link className="" to="/program">Programs</Link>  <ProgramBreadcrumb program={program} linkSelf={true} /> / Sub Programs </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <DataTable organization={organization} program={program} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const TableWrapper = ({ organization, theme, rtl }) => {
  const { programId } = useParams();
  const [programData, setProgramData] = useState(null);
  useEffect(() => {
    if (organization && programId) {
      getProgramById(organization.id, programId, {'hierarchy':true})
        .then(p => {
          setProgramData(p)
        })
    }
  }, [organization, programId])

  if (!organization || !programData) return 'Loading...'

  return (
    <QueryClientProvider client={queryClient}>
      <SubProgram organization={organization} program={programData} theme={theme} rtl={rtl} />
    </QueryClientProvider>
  )
}

export default withRouter(connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization
}))(TableWrapper));

// export default SubProgram;
